import pxToRem from "../../functions/pxToRem";

export default function formControlLabel({ colors, typography }) {
  const { text } = colors;
  const { size, fontWeightBold } = typography;

  const formControlLabel = {
    styleOverrides: {
      root: {
        display: "block",
        minHeight: pxToRem(24),
        marginBottom: pxToRem(2),
      },

      label: {
        display: "inline-block",
        fontSize: size.sm,
        fontWeight: fontWeightBold,
        color: text.primary,
        lineHeight: 1,
        transform: `translateY(${pxToRem(1)})`,
        marginLeft: pxToRem(4),

        "&.Mui-disabled": {
          color: text.primary,
        },
      },
    },
  };

  return formControlLabel;
}
